export default __webpack_public_path__ + "88e2f9025e11c7710934b5597af617af.png";